/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContainerGraphNodeDto } from './ContainerGraphNodeDto';
import {
    ContainerGraphNodeDtoFromJSON,
    ContainerGraphNodeDtoFromJSONTyped,
    ContainerGraphNodeDtoToJSON,
    ContainerGraphNodeDtoToJSONTyped,
} from './ContainerGraphNodeDto';
import type { ContainerGraphEdgeDto } from './ContainerGraphEdgeDto';
import {
    ContainerGraphEdgeDtoFromJSON,
    ContainerGraphEdgeDtoFromJSONTyped,
    ContainerGraphEdgeDtoToJSON,
    ContainerGraphEdgeDtoToJSONTyped,
} from './ContainerGraphEdgeDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ContainerGraphTraversalResponse
 */
export interface ContainerGraphTraversalResponse {
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphTraversalResponse
     */
    seedType?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphTraversalResponse
     */
    seedValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphTraversalResponse
     */
    seedEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphTraversalResponse
     */
    seedEntityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContainerGraphTraversalResponse
     */
    seedResolved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContainerGraphTraversalResponse
     */
    truncated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContainerGraphTraversalResponse
     */
    maxHops?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerGraphTraversalResponse
     */
    maxNodes?: number;
    /**
     * 
     * @type {Array<ContainerGraphNodeDto>}
     * @memberof ContainerGraphTraversalResponse
     */
    nodes?: Array<ContainerGraphNodeDto>;
    /**
     * 
     * @type {Array<ContainerGraphEdgeDto>}
     * @memberof ContainerGraphTraversalResponse
     */
    edges?: Array<ContainerGraphEdgeDto>;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphTraversalResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof ContainerGraphTraversalResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ContainerGraphTraversalResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ContainerGraphTraversalResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ContainerGraphTraversalResponse interface.
 */
export function instanceOfContainerGraphTraversalResponse(value: object): value is ContainerGraphTraversalResponse {
    return true;
}

export function ContainerGraphTraversalResponseFromJSON(json: any): ContainerGraphTraversalResponse {
    return ContainerGraphTraversalResponseFromJSONTyped(json, false);
}

export function ContainerGraphTraversalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerGraphTraversalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seedType': json['seedType'] == null ? undefined : json['seedType'],
        'seedValue': json['seedValue'] == null ? undefined : json['seedValue'],
        'seedEntityType': json['seedEntityType'] == null ? undefined : json['seedEntityType'],
        'seedEntityId': json['seedEntityId'] == null ? undefined : json['seedEntityId'],
        'seedResolved': json['seedResolved'] == null ? undefined : json['seedResolved'],
        'truncated': json['truncated'] == null ? undefined : json['truncated'],
        'maxHops': json['maxHops'] == null ? undefined : json['maxHops'],
        'maxNodes': json['maxNodes'] == null ? undefined : json['maxNodes'],
        'nodes': json['nodes'] == null ? undefined : ((json['nodes'] as Array<any>).map(ContainerGraphNodeDtoFromJSON)),
        'edges': json['edges'] == null ? undefined : ((json['edges'] as Array<any>).map(ContainerGraphEdgeDtoFromJSON)),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ContainerGraphTraversalResponseToJSON(json: any): ContainerGraphTraversalResponse {
    return ContainerGraphTraversalResponseToJSONTyped(json, false);
}

export function ContainerGraphTraversalResponseToJSONTyped(value?: ContainerGraphTraversalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seedType': value['seedType'],
        'seedValue': value['seedValue'],
        'seedEntityType': value['seedEntityType'],
        'seedEntityId': value['seedEntityId'],
        'seedResolved': value['seedResolved'],
        'truncated': value['truncated'],
        'maxHops': value['maxHops'],
        'maxNodes': value['maxNodes'],
        'nodes': value['nodes'] == null ? undefined : ((value['nodes'] as Array<any>).map(ContainerGraphNodeDtoToJSON)),
        'edges': value['edges'] == null ? undefined : ((value['edges'] as Array<any>).map(ContainerGraphEdgeDtoToJSON)),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

